<div class="form-group" [ngClass]="{ required: markAsRequired, valid: markAsValid }">
	<label class="col-form-label" [for]="id">{{ label }}</label>
	<div class="input-field">
		<div class="position-relative">
			<input
				class="form-control"
				ngbDatepicker
				#datePicker="ngbDatepicker"
				[formControl]="control"
				[placeholder]="placeholder"
				[name]="id"
				[ngClass]="{ 'is-invalid': isInvalid(control) }"
				[id]="id"
				[tabindex]="tabIndex"
				[placement]="'bottom-right'"
			/>
			<button class="btn btn-link" type="button" (click)="datePicker.toggle()">
				<i class="cfe cfe-calendar"></i>
			</button>
		</div>

		<div class="invalid-feedback" *ngIf="isInvalid(control)">
			<small *ngIf="inputErrors(control, 'required')">{{ 'inputDate.error.dateRequired' | translate }}</small>
			<small *ngIf="inputErrors(control, 'invalid')">{{ 'inputDate.error.invalidDate' | translate }}</small>
			<small *ngIf="inputErrors(control, 'requiredBefore')">{{ 'inputDate.error.minDate' | translate }}</small>
			<small *ngIf="inputErrors(control, 'requiredAfter')">{{ 'inputDate.error.maxDate' | translate }}</small>
		</div>
	</div>
</div>
